// 商家Pc / 移动端
export default {
  isLogin() {
    var user = this.getCookie('user')
    try {
      user = JSON.parse(user)
      return user
    } catch (e) {
      return false
    }
  },
  logout(params) {
    this.delCookie('user');
    this.toHome(params);
  },
  saveUserInfo(userInfo) {
    this.setCookie("user", JSON.stringify(userInfo));
  },
  updateUseInfo(newInfo) {
    var userInfo = this.isLogin()
    if (userInfo) {
      for (var i in newInfo) {
        userInfo[i] = newInfo[i]
      }
      this.saveUserInfo(userInfo)
    }
  },
  bindStore(context, storeId) { // 切换绑定的门店
    return new Promise((resolve, reject) => {
      Promise.all([context.$api.bindStore({
        businessId: storeId
      }), context.$api.getRefreshBuss({
        businessId: storeId
      })]).then(([bindRes, stateRes]) => {
        if (bindRes.error || stateRes.error) {
          resolve({
            error: true,
            businessId: storeId
          })
          return context.$message.error(bindRes.error ? bindRes.msg : stateRes.msg)
        };
        // bussLocalInfo.csEmail csPhone csWechat offset timeZone
        var privileges = context.$utils.parsePrivileges(bindRes.data.privileges);
        var available = bindRes.data.role != 'owner' ? true : stateRes.data.bussReviewInfo.bindStatus == 'binded';
        context.$store.commit('UPDATE_CUR_BUSINESS', {
          id: storeId,
          available: available,
          privileges: privileges,
          role: bindRes.data.role,
          timeZone: stateRes.data.bussLocalInfo.timeZone,
          storeReview: stateRes.data.bussReviewInfo,
          valueAddInfos: stateRes.data.valueAddInfos
        });
        context.$utils.updateUseInfo({
          businessId: storeId,
          available: available,
          role: bindRes.data.role,
          privileges: privileges,
          timeZone: stateRes.data.bussLocalInfo.timeZone,
          valueAddInfos: stateRes.data.valueAddInfos
        });
        this.setTimezone(stateRes.data.bussLocalInfo.timeZone);
        resolve({
          success: true,
          businessId: storeId
        })
      })
    })
  },
  hasPrivileges(context, privilegeName) {
    var privileges = context.$store.state.businessInfo.privileges;
    var isOwner = context.$store.state.businessInfo.role == 'owner';
    if (privilegeName == 'isOwner') {
      return isOwner;
    }
    if (privileges == '*') {
      return true;
    }
    var selectPri = this.pickByKey(privileges, 'nameEn', privilegeName);
    if (!selectPri || !selectPri.available) {
      return false;
    }
    return true;
  },
  parsePrivileges(privileges) {
    try {
      if (typeof privileges == 'string' && privileges != '*') {
        privileges = JSON.parse(privileges);
      }
      // 有时候后台的数据会转码两次
      if (typeof privileges == 'string' && privileges != '*') {
        privileges = JSON.parse(privileges);
      }
    } catch (e) {}
    return privileges
  },
  formatPrivileges(privileges) {
    return typeof (privileges) == 'string' ? privileges : JSON.stringify(privileges);
  },
  busiStoresSort(stores = []) { // 对不同store状态进行排序
    let success = [],
      fail = [],
      waiting = [],
      other = []
    stores.map(store => {
      if (store.bindStatus == 'binded') {
        success.push(store)
      } else if (store.bindStatus == 'approval_fail') {
        fail.push(store)
      } else if (store.bindStatus == 'under_review') {
        waiting.push(store)
      } else {
        other.push(store)
      }
    })
    return success.concat(fail, other, waiting)
  }
}



// WEBPACK FOOTER //
// ./src/utils/businessCustomerUtils.js